<ui-card [headline]="headline$|async" [cardToolBarItems]="menuItems$|async" [isExpanded]="true">
  <div>
      <ui-table [data]="itemData$|async"
                (gridReady)="onGridReady($event)"
                [undoRedoCellEditing]="false"
                [enableRowAutoSave]="false"
                [enableSorting]="true"
                [enableFilter]="true"
                [renderFullHeight]="false"
                [shrinkToDataHeight]="false"
                [suppressHorizontalScroll]="false"
                (rowClicked)="onRowClicked($event)"
                [id]="'nominationDashboard'"
                #table>
          <ui-table-column
                  name="contractId"
                  headerName="Contract ID"
                  [editable]="false">
          </ui-table-column>
          <ui-table-column
                  name="svcRequesterName"
                  headerName="Svc Req Name"
                  [editable]="false">
          </ui-table-column>
          <ui-table-column
                  name="rateScheduleCd"
                  headerName="Rate Schedule"
                  [editable]="false">
          </ui-table-column>
      </ui-table>
  </div>
</ui-card>
